import { render } from "./ArticleGalleryComp.vue?vue&type=template&id=4a7d32e6&scoped=true"
import script from "./ArticleGalleryComp.vue?vue&type=script&lang=js"
export * from "./ArticleGalleryComp.vue?vue&type=script&lang=js"

import "./ArticleGalleryComp.vue?vue&type=style&index=0&id=4a7d32e6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\LENOVO\\Documents\\workspace\\tulumoutdoor_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7d32e6"]])

export default __exports__